export const WORK_SCHEDULE_SERVICE_INITIAL_STATE: { page: number } = {
  page: 1,
};
